class Controller {
  constructor(name, callback) {
    this.name = name;
    this.callback = callback;
  }

  dispatch(...args) {
    console.log(`Dispatching controller: ${this.name}`);

    if (typeof this.callback !== undefined) {
      return this.callback(...args);
    }
  }
}

module.exports = Controller;
